module.exports = __webpack_public_path__ + "93c8d875b8dac3899c6e0a777c3f9648.pdf";